import React from "react";
import { withCartContext } from "./cartContext.jsx";

const ProgressBar = ({ progress }) => {
  progress = progress > 100 ? 100 : progress;

  const progressBarLine = {
    width: `${progress}%`,
  };

  return (
    <div className="mini-cart__shipping-threshold-progressbar">
      <div
        style={progressBarLine}
        className={`mini-cart__shipping-threshold-progressbar-line ${
          progress === 100 ? "mini-cart__shipping-threshold-progressbar-line--full" : ""
        }`}
      ></div>
    </div>
  );
};

export default withCartContext(ProgressBar);
